import { useQuery } from 'react-query';
import { JudgeAPI } from 'api/admin/judge';
import { JUDGE } from 'helpers/constants';

export default function useJudge(id) {
  return useQuery([JUDGE, id], () => JudgeAPI.getOneById(id));
}
